// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"182":"4e236fc4","337":"c9ca3892","508":"4b412225","828":"6cc522b3","842":"01821987","851":"3f0086ba"}[chunkId] + ".chunk.js";
};